import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useAnalytics } from '@/hooks/useAnalytics';

const FinalCTASection = () => {
  const navigate = useNavigate();
  const { trackCTAClick, trackOnboardingStart } = useAnalytics();

  const handleGetEarlyAccess = () => {
    trackCTAClick('final');
    trackOnboardingStart();
    navigate('/early-access');
  };
  return <section id="final-cta" className="py-24 bg-gradient-to-br from-yellow-400 via-orange-400 to-red-400 relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-32 h-32 bg-white/20 rounded-full blur-3xl animate-pulse-gentle"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-white/10 rounded-full blur-3xl animate-pulse-gentle delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-60 h-60 bg-white/5 rounded-full blur-3xl"></div>
      </div>

      <div className="container max-w-4xl mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-7xl font-black text-white mb-6 tracking-tight">
            Ready to
            <span className="flex items-center justify-center text-purple-900">
              <img alt="Show Up mascot - happy character encouraging habit building" className="w-16 h-16 md:w-20 md:h-20 mr-3 md:mr-4 drop-shadow-lg hover:scale-110 transition-transform duration-300 animate-bounce-gentle" src="/lovable-uploads/cbec68a8-66ec-428f-a0b5-00c0d5de9a87.png" loading="lazy" />
              show up?
            </span>
          </h2>
          <p className="text-2xl md:text-3xl text-white/90 font-bold max-w-3xl mx-auto leading-relaxed mb-8">
            Join the experiment. See what happens when you stop overcomplicating.
          </p>
        </div>

        {/* App Status */}
        <div className="bg-white/20 backdrop-blur-lg rounded-3xl p-8 mb-12 border border-white/30">
          <div className="text-center">
            <h3 className="text-2xl font-black text-white mb-4">
              Show Up! is launching soon
            </h3>
            <p className="text-lg text-white/90 font-medium leading-relaxed max-w-2xl mx-auto">
              We're currently testing with select users to make sure we get it right. 
              Get early access by completing our quick pre-onboarding flow.
            </p>
          </div>
        </div>

        {/* Main CTA */}
        <div className="text-center mb-12">
          <Button onClick={handleGetEarlyAccess} className="bg-yellow-400 hover:bg-yellow-300 text-purple-900 font-black px-12 py-6 rounded-2xl shadow-2xl hover:scale-105 transition-all duration-300 text-xl">
            Get Early Access
          </Button>
          <p className="text-white/80 mt-4 font-medium">
            Takes less than 2 minutes • Secure your spot now
          </p>
        </div>

        {/* Benefits & Urgency */}
        <div className="text-center space-y-6">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 inline-block">
            <p className="text-white font-bold text-lg">
              🎁 <span className="text-yellow-100">Bonus:</span> Get our 'PACT Design Guide' when you join
            </p>
          </div>
          
          <div className="flex items-center justify-center gap-3">
            <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></div>
            <p className="text-white font-bold">
              Limited beta spots available
            </p>
          </div>

          {/* Social Proof */}
          <div className="flex items-center justify-center gap-4 mt-8">
            <div className="flex -space-x-2">
              {[...Array(8)].map((_, i) => <div key={i} className="w-10 h-10 bg-gradient-to-br from-purple-400 to-pink-400 rounded-full border-2 border-white"></div>)}
            </div>
            <div className="text-left">
              <p className="text-white font-bold">67 people ready to show up</p>
              <p className="text-white/80 text-sm">Join them today</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default FinalCTASection;